function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-nocheck
import * as _ from "lodash";
import AccesoServicios from "../services/AccesoServicios";
import { $unibase } from "../uni-base-module";
var _defaultDelay = 1000;
export var UniStore = /*#__PURE__*/function () {
  function UniStore(endpoint, errorMsg, localStorageConfig, keybyComparator, listKeyComparator, $log, $resource, AccesoServicios, localStorageService, UniConfig) {
    _classCallCheck(this, UniStore);
    this.endpoint = endpoint;
    this.localStorageConfig = localStorageConfig;
    this.listKeyComparator = listKeyComparator;
    this.$log = $log;
    this.$resource = $resource;
    this.AccesoServicios = AccesoServicios;
    this.localStorageService = localStorageService;
    this.UniConfig = UniConfig;
    this._keyby = keybyComparator;
    this.resource = $resource(UniConfig.urlServiciosProg + endpoint, {}, AccesoServicios.defaults(errorMsg));
    this.leido = false;
  }
  return _createClass(UniStore, [{
    key: "load",
    value: function load(forzarServidor) {
      this.loadStore.call(this, forzarServidor);
    }
  }, {
    key: "loadServidor",
    value: function loadServidor() {
      var _this = this;
      return this.resource.query(function (serverData) {
        // si keybyComparator es una función, usarla para generar el data
        if (typeof _this._keyby === "function") {
          console.log("Generar data de store con funcion");
          _this.data = _this._keyby(serverData);
        } else {
          // generar un data clasificando datos con el keybyComparator si existe, y
          // guarda el resultado en un list

          _this.data = {
            map: {},
            list: []
          };
          if (_this._keyby) {
            // generar lista
            if (_this.listKeyComparator) _this.data.map = _.keyBy(serverData, _this.listKeyComparator);else _this.data.map = _.keyBy(serverData, _this._keyby);
          }
          _this.data.list = serverData;
        }

        // guardar en el localStorage si está activo
        if (_this.UniConfig.useLocalStorage && _this.localStorageConfig.activo) {
          _this.localStorageService.set(_this.localStorageConfig.key, _this.data);
        }
        _this.leido = true;
      }).$promise;
    }
  }, {
    key: "loadStore",
    value: function loadStore(cargaServidor) {
      var _store = this;
      if (cargaServidor)
        // forzar lectura
        return this.loadServidor.call(this);else if (!this.leido) {
        // intentar leer datos de localstorage
        var datos;
        if (this.UniConfig.useLocalStorage && this.localStorageConfig.activo) {
          datos = this.localStorageService.get(this.localStorageConfig.key);
        }
        if (datos) {
          // los datos están en localStorage, guay
          // _store.data.map = datos.map;
          // _store.data.list = datos.list;

          _store.data = datos;
        } else {
          this.loadServidor.call(this);
        }
      } else {
        // ya leído !
        console.log("Volviendo a hacer load de datos ya leídos del store " + this.endpoint, _store);
      }
    }
  }]);
}();

/*
    function cargarDatosServidor(callback) {

        initClinicasStore();

        _resourceClinicas.query(function (list) {
            $log.debug(list);

            _store.clinicasList = list;

            // obtener los centros
            _.each(_store.clinicasList, function (clinica) {

                // nombre
                setNombreClinica(clinica);

                // dict de clinicas
                _store.clinicas[clinica.idclinica] = clinica;

                if (clinica.idcentro && !_store.centros[clinica.idcentro]) {
                    _store.centros[clinica.idcentro] = clinica.centro;
                    _store.centrosList.push(clinica.centro);
                }
            });

            // guardar datos en localStorage
            if (UniConfig.useLocalStorage && UniConfig.clinicasKey.activo)
                this.localStorageService.set(UniConfig.clinicasKey.key, _store);

            callback(_store);
        });
    }
    */

$unibase.factory("UniStore", ["$log", "$resource", "AccesoServicios", "localStorageService", "UniConfig", function ($log, $resource, AccesoServicios, localStorageService, UniConfig) {
  return function (endpoint, errorMsg, localStorageConfig, keybyComparator, listKeyComparator) {
    return new UniStore(endpoint, errorMsg, localStorageConfig, keybyComparator, listKeyComparator, $log, $resource, AccesoServicios, localStorageService, UniConfig);
  };
}]);